/**
@prop --ux-auto-hide: Set to false to disable the default auto-hide behavior
@prop --ux-max-height: Set the scrollpanel max height
 */
:host {
  --scrollbar-size: var(--ux-scrollbar-size, 24px);

  display: block;
  width: 100%;
  height: 100%;
  max-height: var(--ux-max-height, none);
  position: relative;
}

.content {
  position: absolute;
  inset: 0;
  overflow: auto;
  overflow-scrolling: touch;
  scrollbar-width: none;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }
}

.scrollbars {
  position: absolute;
  pointer-events: none;
  inset: 0;
  transition: opacity .5s ease;

  &.inactive {
    opacity: 0;
  }

  @container style(--ux-auto-hide: false) {
    transition: none;

    &.inactive {
      opacity: 1;
      transition: none;
    }
  }
}

:host([scrollbars=horizontal]) {
  .content {
    @container style(--ux-auto-hide: false) {
      padding-bottom: var(--scrollbar-size);
    }
  }
}

:host([scrollbars=vertical]) {
  .content {
    @container style(--ux-auto-hide: false) {
      padding-right: var(--scrollbar-size);
    }
  }
}

:host([scrollbars=both]) {
  .content {
    @container style(--ux-auto-hide: false) {
      padding-right: var(--scrollbar-size);
      padding-bottom: var(--scrollbar-size);
    }
  }
}
